var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPotato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 91,
    viewBox: "0 0 87 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.5L36.5 26.5",
    stroke: "#D79E37",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1248 70.248C67.8166 82.8048 41.0204 85.0238 27.0117 59.0137C18.0055 39.5065 6.21979 18.3841 23.5003 11.5006C36.7281 6.23138 42.5033 8.00375 57.0107 28.5124C65.149 40.0174 86.0216 51.5251 75.1248 70.248Z",
    fill: "#E7AD42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.5C31.5 29.5 32.6763 28.5242 33.5 28C34.6051 27.2968 36.5 26.5 36.5 26.5",
    stroke: "#A3782A",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 44C51 44 52.1763 43.0242 53 42.5C54.1051 41.7968 56 41 56 41",
    stroke: "#A3782A",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 41C29 41 30.1763 40.0242 31 39.5C32.1051 38.7968 34 38 34 38",
    stroke: "#A3782A",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56C43 56 44.1763 55.0242 45 54.5C46.1051 53.7968 48 53 48 53",
    stroke: "#A3782A",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59C61 59 62.1763 58.0242 63 57.5C64.1051 56.7968 66 56 66 56",
    stroke: "#A3782A",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotato);
export default __webpack_public_path__ + "static/media/potato.cf634830268e1d55ba53e8cede6dd798.svg";
export { ForwardRef as ReactComponent };